import { render, staticRenderFns } from "./file_upload_demo.vue?vue&type=template&id=23d4a9a0&scoped=true&"
import script from "./file_upload_demo.vue?vue&type=script&lang=ts&"
export * from "./file_upload_demo.vue?vue&type=script&lang=ts&"
import style0 from "./file_upload_demo.vue?vue&type=style&index=0&id=23d4a9a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d4a9a0",
  null
  
)

export default component.exports